import { useEffect, useState } from "react";

import BASE_URL from "../services/api";

function Volunteers() {
  const [volunteers, setVolunteers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPendingVolunteers();
  }, []);

  const fetchPendingVolunteers = async () => {
    try {
      const res = await fetch(`${BASE_URL}/admin/volunteers/pending`);
      const data = await res.json();
      setVolunteers(data);
    } catch (err) {
      console.error(err);
      alert("Failed to load volunteers");
    } finally {
      setLoading(false);
    }
  };

  const approveVolunteer = async (id) => {
    const password = prompt("Set password for volunteer");
    if (!password) return;

    await fetch(`${BASE_URL}/admin/volunteer/approve`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ volunteer_id: id, password }),
    });

    alert("Volunteer Approved");
    fetchPendingVolunteers();
  };

  const rejectVolunteer = async (id) => {
    await fetch(`${BASE_URL}/admin/volunteer/reject`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ volunteer_id: id }),
    });

    alert("Volunteer Rejected");
    fetchPendingVolunteers();
  };
  console.log(volunteers);

  return (
    <div style={{ display: "flex" }}>
      <div className="page-content">
        <div className="dashboard-card volunteers-card">
          <h2 className="page-title">Volunteer Requests</h2>

          {loading ? (
            <p>Loading...</p>
          ) : volunteers.length === 0 ? (
            <p style={{ color: "#666" }}>No pending volunteers</p>
          ) : (
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {volunteers.map((v) => (
                  <tr key={v.id}>
                    <td>{v.name}</td>
                    <td>{v.email}</td>
                    <td>{v.phone}</td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="approve-btn"
                          onClick={() => approveVolunteer(v.id)}
                        >
                          Approve
                        </button>
                        <button
                          className="reject-btn"
                          onClick={() => rejectVolunteer(v.id)}
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default Volunteers;
